<template>
    <BaseWrapper :loading="loading">
        <div class="space-y-4">
            <div class="flex items-center justify-end gap-2">
                <base-input type="search" placeholder="Cari kode atau nama" :shadow="false" debounce
                    v-model="filter.search" @native-input="loadOfficeDataChanges" />

                <BaseButton tag="router-link" :to="{ name: 'perubahan-data.tambah' }">
                    <Icon icon="heroicons:plus" />
                    Tambah Data
                </BaseButton>
            </div>
            <datatable :columns="[
                {
                    id: 'date',
                    name: `Tanggal`,
                },
                {
                    id: 'code',
                    name: `Kode Mitra Usaha`,
                },
                {
                    id: 'name',
                    name: `Nama Mitra Usaha`,
                },
            ]" :total="officeDataChanges.meta.page.total" :perPage="officeDataChanges.meta.page.perPage"
                :currentPage="officeDataChanges.meta.page.currentPage" @pagechanged="onChangePage">
                <template #tbody="{ classes }">
                    <tr v-for="officeDataChange in officeDataChanges.data" :key="officeDataChange.id"
                        :class="[classes.tr, 'cursor-pointer bg-white hover:bg-green-100']"
                        @click="onClickDetail(officeDataChange)">
                        <td :class="[classes.td]">
                            {{ officeDataChange.attributes.createdAt | formatDate }}
                        </td>
                        <td :class="[classes.td]">
                            <span class="font-bold text-gray-900">
                                {{ officeDataChange.attributes.office_code }}
                            </span>
                            /
                            <span>
                                {{ officeDataChange.attributes.office_temp_code }}
                            </span>
                        </td>
                        <td :class="[classes.td]">
                            {{ officeDataChange.attributes.office_name }}
                        </td>
                    </tr>
                </template>
            </datatable>
        </div>
        <ViewOfficeDataChangeModal
      :visible="detailModal.visible"
      :id="detailModal.id"
      @close="detailModal.visible = false"
    />
    </BaseWrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapActions, mapGetters } from 'vuex';
import ViewOfficeDataChangeModal from '../../../../components/office-data-change/ViewOfficeDataChangeModal.vue';

export default {
    mixins: [requestMixin],
    components: { ViewOfficeDataChangeModal },
    data() {
        return {
            detailModal: {
                id: null,
                visible: false,
            },
            filter: {
                search: null,
            },
            loading: false,
            officeDataChanges: {
                data: [],
                meta: {
                    page: {},
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            me: 'auth/getUser',
        }),
    },
    methods: {
        ...mapActions({
            createAlert: 'alert/createAlert',
        }),
        async loadOfficeDataChanges(params) {
            this.loading = true;

            const [res, err] = await this.request('/api/v1/office-data-changes', {
                params: {
                    'page[size]': 5,
                    'filter[search]': this.filter.search,
                    sort: '-createdAt',
                    ...params,
                },
            });

            if (!err) {
                this.officeDataChanges = res;
            }

            this.loading = false;
        },
        onChangePage(page) {
            this.loadOfficeDataChanges({
                'page[number]': page,
            });
        },
        onClickDetail(officeDataChange) {
            this.detailModal.id = officeDataChange.id;
            this.detailModal.visible = true;
        },
    },
    created() {
        this.loadOfficeDataChanges();
    },
};
</script>
